export default "__VITE_ASSET__rFx81QV9__"